import { Vue, i18n } from 'Common/vue';

// import components
import Autocomplete from 'VueComponents/Autocomplete.vue';
import Minicart from 'VueComponents/Minicart.vue';

import 'Ui/toggle';
import 'Components/navigation';
import 'Common/sticky-header';

window.$_autocomplete = new Vue({
    i18n,
    render: h => h(Autocomplete)
}).$mount("#autocomplete");

window.$_minicart = new Vue({
    i18n,
    render: h => h(Minicart)
}).$mount("#minicart");

const catFilterElem = document.querySelector('#categoriesFilter');

if (catFilterElem) {
    const productsCategories = catFilterElem.dataset.categories;
    const selectedCategoryId = catFilterElem.dataset.selected;

    new Vue({
        el: '#categoriesFilter',
        components: {
            CategoriesFilter: () => import('VueComponents/CategoriesFilter.vue')
        },
        template: `<CategoriesFilter :select-category-id="${selectedCategoryId || null}" :products-categories="${productsCategories}"></CategoriesFilter>`
    });
}

document.querySelector('.js-trigger-search').addEventListener('click', event => {
    event.preventDefault();

    Event.dispatch("Autocomplete.showForm");
});